import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';

import Avatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Avatar';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import { DataValueMap } from 'Helpers/Testing';
import OutOfOfficeIndicator from './AvatarOutOfOfficeIndicator';

const styles = theme => ({
  root: {
    position: 'relative',
  },
  avatar: {
    position: 'relative',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.facet.primaryBlue,
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
});

const MessageAvatar = ({
  className,
  classes,
  messageResource,
  AvatarProps,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Avatar
        className={classes.avatar}
        alt={`${messageResource.attr('from')} profile image`}
        src={messageResource.relationship(fr.relationships.profileImage.name)?.link('self')?.attr('url')}
        {...AvatarProps}
        {...DataValueMap.init('message-avatar')
          .append(DataValueMap.keyMap.dataResourceId, messageResource.id())
          .build()}
      >
        {/* Fallback initials go here */}
      </Avatar>
      <OutOfOfficeIndicator
        messageResource={messageResource}
      />
    </div>
  );
};

MessageAvatar.defaultProps = {
  className: '',
  AvatarProps: {},
};

MessageAvatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  messageResource: PropTypes.object.isRequired,
  AvatarProps: PropTypes.object,
};

export default withStyles(styles)(MessageAvatar);
